import { createFileRoute } from '@tanstack/react-router';

// relative imports
import TirFilesPage from '../../components/file-management/TirFilesPage';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/files')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: TirFilesPage,
  staticData: {
    configPageId: 'file-management',
    meta: {
      title: 'File Management | Ledgible',
    },
  },
});
